export const O11Y_PORTAL_ID = 'o11y-portal';

// Traces search clause that restricts results to LLM (gen_ai) spans. Shared so
// the Traces filter toggle and any pre-seeded links agree on a single value.
export const LLM_SPANS_FILTER_QUERY = 'launchdarkly.operation.type=gen_ai';

export const AI_BOT_NAME = 'Vega';

// Pagination
export const START_PAGE = 1;
